import React from 'react';
import homeImg from '../assets/homeimg.svg';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
export default function HomePage() {
    return (
        <div className='bg-home-bg min-h-screen h-auto w-full flex flex-col justify-between'>
            <div>
            <Navbar bgrenk="bg-home-bg" renk="text-home-pr" renk2="text-home-sc"></Navbar>
            <div className='flex flex-col lg:flex-row justify-between mx-5 md:mx-[150px] items-center '>
                <div> 
                    <h1 className='text-4xl md:text-6xl flex md:leading-[75px] font-semibold text-home-pr'>Merhaba, ben Çağla<span className="ml-3 animate-waving-hand">👋</span></h1>
                    <p className='text-2xl md:text-3xl leading-[52px] font-[400] max-w-[600px] mt-4 mb-8 text-home-sc'>Frontend ve Mobile Developer'ım ve ReactJS, React Native ve TypeScript ile <span><a className='underline text-home-sc hover:text-home-pr' target="_blank" href="https://github.com/caglaunsall" rel="noreferrer">projeler</a></span> geliştiriyorum. Aynı zamanda Next.js, Vue.js ve Nuxt.js gibi teknolojilere de hakimim.</p>
                    <div className='flex gap-x-5 justify-center lg:justify-start'>
                    <a className='border-[1px] px-3 py-2 rounded-3xl text-[20px] border-home-sc text-home-sc hover:text-home-pr'  target="_blank" rel="noreferrer" href="https://github.com/caglaunsall">Github</a>
                    <a className='border-[1px] px-3 py-2 rounded-3xl text-[20px] border-home-sc text-home-sc hover:text-home-pr'  target="_blank" rel="noreferrer" href="https://flowcv.com/resume/itg92cqbnm">Resume</a>
                    <a className='border-[1px] px-3 py-2 rounded-3xl text-[20px] border-home-sc text-home-sc hover:text-home-pr' target="_blank" rel="noreferrer" href="https://bento.me/benduydumpodcast">Podcast</a>
                    </div>
                </div>
                <div>
                    <img className='w-[240px] md:w-[437px]' src={homeImg} alt="" />
                </div> </div>
                </div>
            <Footer renk2="text-home-sc"></Footer>
        </div>
    )
}
